import { GetServerSideProps } from 'next';

import ClientApp from '~/ClientApp';
import WeddingHead from '~/components/common/layouts/head/WeddingHead';
import { UserContextProvider } from '~/contexts/UserContext';
import WeddingRoutes from '~/routes/WeddingsRoutes';

interface InspirationPageProps {
  canonicalUrl: string;
  noIndex: boolean;
}

const StorefrontPage = ({ noIndex = false, canonicalUrl }: InspirationPageProps) => {
  return (
    <UserContextProvider>
      <WeddingHead canonicalUrl={canonicalUrl} noindex={noIndex} />
      <ClientApp>
        <WeddingRoutes />
      </ClientApp>
    </UserContextProvider>
  );
};

// eslint-disable-next-line @typescript-eslint/require-await
export const getServerSideProps: GetServerSideProps<InspirationPageProps> = async (context) => {
  const { pathSlug } = context.params || {};
  const canonicalPath = Array.isArray(pathSlug) ? `/${pathSlug.join('/')}` : '';
  const canonicalUrl = `https://www.zola.com/inspiration${canonicalPath}`;
  const noIndex = canonicalPath.includes('/photo/');
  return {
    props: {
      canonicalUrl,
      noIndex,
    },
  };
};

export default StorefrontPage;
